import React from 'react';
import AkaaniLogoWhite from '@design-system/Assets/AkaaniLogoWhite';
import TwitterIcon from '@design-system/Assets/TwitterIcon';
import FbIcon from '@design-system/Assets/FbIcon';
import IgIcon from '@design-system/Assets/IgIcon';

export default function Footer() {
  return (
    <footer className="mt-10 gap-6 md:gap-0 bg-ak200 flex flex-col md:flex-row justify-between items-center py-8 px-16">
      <AkaaniLogoWhite />

      <ul className="flex flex-row gap-7">
        <li>
          <a href="https://twitter.com/useakaani">
            <TwitterIcon />
          </a>
        </li>
        <li>
          <a href="https://instagram.com/sellabyakaani">
            <IgIcon />
          </a>
        </li>
        <li>
          <a href="https://www.facebook.com/useakaani">
            <FbIcon />
          </a>
        </li>
      </ul>

      <div className="flex items-center">
        <span className="text-white">© 2023. All rights reserved.</span>
      </div>
    </footer>
  );
}
